'use client';
import { useEffect, useState } from 'react';
import { Lesson } from '@/types/courseDt';
import { useProgress } from '@/hooks/useProgress';
import ProgressCircle from './ProgressCircle';

export default function LessonProgress({ lesson }: { lesson: Lesson }) {
  const { progress } = useProgress();
  const [lessonProgress, setLessonProgress] = useState(0);

  useEffect(() => {
    const currentProgress = progress?.lessonsProgress[lesson.lessonId.current];
    if (!currentProgress) return;
    setLessonProgress(currentProgress?.progress ?? 0);
  }, [progress]);
  return <ProgressCircle percentage={lessonProgress} color="#222222" />;
}
